
export class ScheduleEntryModel {
    constructor(
        public presentationId: string,
        public startDate?: any,
        public endDate?: any
    ) { }
}


// WEBPACK FOOTER //
// ./src/app/views/devices/models/scheduleEntry.model.ts